<app-main-navbar [state]="sidebarState" (sidebarClick)="onClicked($event)" ></app-main-navbar>
<div class="main">
    <app-main-sidebar [initLink]="initLink" [state]="sidebarState" ></app-main-sidebar>
    <div style="flex-grow:1;">
        <router-outlet></router-outlet>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main.component.html